import { render, staticRenderFns } from "./NewTransactionCard.vue?vue&type=template&id=1f943cc0"
import script from "./NewTransactionCard.vue?vue&type=script&lang=js"
export * from "./NewTransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports